import apiUrl from 'common/api-url';
import { xhr } from 'common/xhr';

// Reconnect's `EnrichedCustomerData` equivalent:
export interface CustomerInfo {
  active?: boolean;
  birthDay?: number;
  birthMonth?: number;
  birthYear?: number;
  blocked?: boolean;
  blockedReason?: string;
  emailAddress?: string;
  gender?: 'MALE' | 'FEMALE';
  id?: number;
  isWithinVenueRetentionPeriod?: boolean;
  lastAppointmentCommissionType?:
    | 'NONEXISTENT'
    | 'NEW'
    | 'REPEAT_IN_RETENTION_PERIOD'
    | 'REPEAT_NOT_IN_RETENTION_PERIOD';
  locale?: string;
  name?: string;
  notes?: string;
  phone?: string;
  prepaymentRequired?: boolean;
  sendMassEmails?: boolean;
  withinVenueRetentionPeriod?: boolean;
}

export const fetchCustomerInfo = (venueCustomerId: number) =>
  xhr.getWithPromise(apiUrl('POS_CUSTOMER_INFO', { venueCustomerId }));
